



















import { defineComponent, onBeforeMount, reactive } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SearchInput from '@/components/organisms/questionnaire-answer/SearchInput.vue'
import QuestionnaireAnswerTable from '@/components/organisms/questionnaire-answer/QuestionnaireAnswerTable.vue'
import useVuex from '@/utils/useVuex'
import {
  QuestionnaireAnswerState,
  QuestionnaireState,
  UserState,
} from '@/types/store'
import { UserRole } from '@/types/user'
import { GetQuestionnaireQuery } from '@/types/questionnaire'

export default defineComponent({
  name: 'UncheckedAutomaticQuestionnaireAnswer',
  components: { Layout, SearchInput, QuestionnaireAnswerTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      questionnaireAnswers: useVuex<
        QuestionnaireAnswerState['questionnaireAnswers']
      >(
        context,
        () => store.getters['questionnaireAnswer/questionnaireAnswers'],
      ),

      isQuestionnaireAnswerLoading: useVuex<
        QuestionnaireAnswerState['isQuestionnaireAnswerLoading']
      >(
        context,
        () => store.getters['questionnaireAnswer/isQuestionnaireAnswerLoading'],
      ),

      completions: useVuex<QuestionnaireState['completeQuestionnaires']>(
        context,
        () => store.getters['questionnaire/completions'],
      ),
    })

    const reset = () => {
      store.dispatch('questionnaireAnswer/getQuestionnaireAnswers', {
        isAutomatic: true,
        checkerCheckStatus: 'non',
        adminCheckStatus: 'non',
      })
    }

    onBeforeMount(() => {
      store.dispatch('questionnaire/getCompleteQuestionnaires', {
        isAutomatic: true,
      })
    })

    const search = (query: GetQuestionnaireQuery) => {
      store.dispatch('questionnaireAnswer/getQuestionnaireAnswers', {
        ...query,
        isAutomatic: true,
      })
    }

    return { state, UserRole, search, reset }
  },
})
